import { Component, Input } from '@angular/core';
import {
    Aangifte,
    BokkzAlgDataService,
    BokkzIbDataService, Box1WinstUitOnderneming, Box3InkomenUitSparenEnBeleggen, Heffingskortingen,
    IncomeTaxEntity, OmschrijvingEnBedrag, Rekening
} from '@snelstart-ventures/fiscaal/domain-logic';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { optionsLandcodesMetNLD } from '../../gedeelde-componenten/gedeelde-componenten.component';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-box3-owr',
    templateUrl: './box3-owr.component.html',
    styleUrls: ['./box3-owr.component.scss'],
    imports: [
        SharedUiAlertModule,
        SharedUiButtonModule,
        ReactiveFormsModule,
        SharedUiFormControlsModule,
        SharedUiTooltipModule
    ]
})

export class Box3OwrComponent {

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;
    public dialogVisible = false;
    public index = 0;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: false, label: 'Nee' },
        { value: true, label: 'Ja' },
    ];

    public owrFg = {} as FormGroup;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.owrFg = this.fb.group({
            berekenWerkelijkRendement: null as unknown as boolean
        });
    }


    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.owrFg.patchValue({
                    berekenWerkelijkRendement: aangifte.box3?.berekenWerkelijkRendement ?? false
                }, { emitEvent: false });
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.owrFg.dirty;
    }


    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            box3: {
                ...this.aangifte.box3,
                berekenWerkelijkRendement: this.owrFg.value.berekenWerkelijkRendement
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
